import api           from '../../../configs/api'
import Form          from '../../../display/forms/FormElements'
import PropertyValue from '../../../things/PropertyValue'
import Thing         from '../../../things/Thing'
import Word          from '../../../things/Word'

const medicalSpecialties =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une spécialité médicale en cliquant ci-dessous.' ,
        elements    :
        [
            {
                type       : Form.SEARCH_SELECTOR ,
                path       : api.thesaurus.medical_specialties ,
                clearLabel : 'Vider' ,
                closeLabel : 'Fermer' ,
                init       :
                {
                    id         : 'value',
                    key        : 'value',
                    label      : 'Spécialité médicale',
                    autoFocus  : false,
                    fullWidth  : true,
                    margin     : 'normal',
                    required   : true,
                    type       : 'search',
                    variant    : 'outlined'
                },
                inputProps :
                {
                    label : 'Spécialité médicale...'
                },
                logics :
                {
                    disabledSuggestions : ( props ) =>
                    {
                        const { rel } = props ;
                        let suggestions = [] ;
                        if( rel instanceof Thing )
                        {
                            const { subjectOf } = rel ;
                            if( subjectOf instanceof Thing )
                            {
                                if( subjectOf instanceof Word )
                                {
                                    suggestions.push( subjectOf ) ;
                                }
                                const { medicalSpecialties } = subjectOf ;
                                if( medicalSpecialties instanceof Array )
                                {
                                    return medicalSpecialties ;
                                }
                            }
                        }
                        return suggestions ;
                    }
                }
            }
        ],
        fail    : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading : 'Chargement en  cours...' ,
        prepare : ( item ) =>
        {
            return (
            {
                value : item.value
            });
        },
        mapUri : ( item , uri ) =>
        {
            if( item instanceof PropertyValue)
            {
                const { value } = item ;
                if( value instanceof Thing )
                {
                    return uri + '/' + value.id ;
                }
            }
            return uri ;
        },
        success : 'Ajout d\'une nouvelle spécialité médicale réussi!' ,
        title   : 'Ajouter une spécialité médicale'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cette spécialité médicale:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer la specilité médicale ?'
    },
    title : 'Spécialités médicales' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default medicalSpecialties ;
